import { atom } from "jotai";
import { UserInfo } from "../interfaces/user";

// Initialize with empty values that match the UserInfo interface
export const user_info = atom<UserInfo>({
  user_email: "",
  payment_status: ""
});
